import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
// import decryptUserCookie from './utils/decryptUserCookie';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { useSidebar } from '../../SidebarContext';
import DepartmentModal from './DepartmentModal';
import { decryptToken } from '../utils/getToken';

const Department = () => {

    const { globalSearch } = useSearch();
    const [searchQuery, setSearchQuery] = useState('');
    // const userDetails = decryptUserCookie();
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState(categories);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    const urlmain = process.env.REACT_APP_LINK
    const [load, setLoad] = useState(false);
    let main_id = "12345"
    // Effect to handle filtering
    const fetchCategories = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${urlmain}/department`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
                // credentials: "include"
            })
            const res = await response.json();
            ;
            setCategories(res || []);
        } catch (error) {
            console.error(error)
        } finally {
            setLoad(false)
        }
    }

    useEffect(() => {
        fetchCategories();
    }, [])


    useEffect(() => {
        const filtered = categories.filter((category) =>
            Object.values(category).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredCategories(filtered);
        setCurrentPage(1);
    }, [globalSearch, categories]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);
    const currentData = filteredCategories.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    // const toggleStatus = (index) => {
    //     const updatedCategories = [...categories];
    //     updatedCategories[index].status = !updatedCategories[index].status;
    //     setCategories(updatedCategories);
    // };

    const toggleStatus = async (userId) => {
        try {
            const response = await fetch(`${urlmain}/department/status/${userId}`, {
                method: 'PATCH',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            const result = await response.json();

            if (!result.isError) {
                const updated = categories.map(cat =>
                    cat.id === parseInt(userId) ? { ...cat, status: result.status } : cat
                );
                setCategories(updated);
                toast.success(result.message);
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error("Toggle failed");
        }
    };


    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${urlmain}/department/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
                const res = await response.json();

                if (response.ok) {
                    setCategories(prev => prev.filter(cat => cat.id !== id));
                    Swal.fire('Deleted!', 'Category has been deleted.', 'success');
                } else {
                    Swal.fire('Error', res.message || 'Delete failed', 'error');
                }
            } catch (error) {
                Swal.fire('Error', 'Something went wrong while deleting.', 'error');
            }
        }
    };


    const handleSave = async (data) => {
        try {
            const method = data.id ? "PUT" : "POST";
            const url = data.id
                ? `${urlmain}/department/change/${data.id}`
                : `${urlmain}/department`;

            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(data),
            });
            const res = await response.json();

            if (response.ok) {
                if (data.id) {
                    setCategories(prev => prev.map(cat => cat.id === data.id ? data : cat));
                    toast.success("Category updated");
                } else {
                    fetchCategories();
                    setCategories(prev => [...prev, res]);
                    toast.success("Category added");
                }
            } else {
                toast.error(res.message || "Save failed");
            }
        } catch (error) {
            toast.error("Save error");
        }
    };


    if (load) {
        return (
            <Loader />
        );
    }




    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Department</h1>
            </div>

            {/* Search Filter */}
            {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

            {/* Customer Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th>Department</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.department_name}</td>

                                    <td>
                                        <button
                                            className={`status-toggle ${customer.status ? 'Active' : 'Inactive'}`}
                                            onClick={() => toggleStatus(customer.id)}
                                        >
                                            {customer.status === "Active" ? (
                                                <i className="fas fa-toggle-on"></i> // Active
                                            ) : (
                                                <i className="fas fa-toggle-off"></i> // Inactive
                                            )}
                                        </button>
                                    </td>
                                    <td>
                                        <button className="edit-button" onClick={() => {
                                            setSelectedCategory(customer);
                                            setIsModalOpen(true);
                                        }}>
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>

                                        <button className="delete-button" onClick={() => handleDelete(customer.id)}>
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>

                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No Department Added.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p style={{ textAlign: "center", margin: "50px" }}>No Department Added</p>
                ) : (
                    currentData.map((group, index) => (
                        <div className="ecom-responsive-card" key={index}>
                            <div className="ecom-responsive-header">
                                <div className='p-toggle'>
                                    <p onClick={() => {
                                        setSelectedCategory(group);
                                        setIsModalOpen(true);
                                    }}>
                                        <Pencil size={20} style={{ marginRight: 4 }} /> <span>Edit</span>
                                    </p>

                                    <button
                                        className={`status-toggle ${group.status === "Active" ? 'Active' : 'Inactive'}`}
                                        onClick={() => toggleStatus(group.id, group.status)}
                                    >
                                        {group.status === "Active" ? (
                                            <>
                                                <LucideToggleRight style={{ marginRight: 4 }} />
                                                <span>Active</span>
                                            </>
                                        ) : (
                                            <>
                                                <LucideToggleLeft style={{ marginRight: 4 }} />
                                                <span>Inactive</span>
                                            </>
                                        )}
                                    </button>
                                </div>

                                <p onClick={() => handleDelete(group.id)}>
                                    <Trash2 size={20} style={{ marginRight: 4 }} /> <span>Delete</span>
                                </p>
                            </div>

                            <div className="ecom-responsive-body">
                                <div className="ecom-responsive-left">
                                    <div className="ecom-image-heading-left">
                                        {/* <img src={group.icon} alt=""
                                                style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                                            /> */}
                                        <span>
                                            <h2>{group.department_name || "Not Provided"}</h2>
                                            {/* <p>Position: {group.status}</p> */}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {totalPages > 1 && (

                <div className="pagination">
                    {/* First Page */}
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>

                    {/* Previous Page */}
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>

                    {/* Current Page Number Only */}
                    <button className="pagination-btn active">
                        {currentPage}
                    </button>

                    {/* Next Page */}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>

                    {/* Last Page */}
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}

            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                <button
                    onClick={() => {
                        setIsModalOpen(true)
                        setSelectedCategory(null)
                    }}
                    className="cssbuttons-io-button">
                    <span>Add Department</span>
                </button>
            </div>

            <DepartmentModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                onSave={handleSave}
                categories={categories}
                setCategories={setCategories}
                fetchCategories={fetchCategories}
            />

        </>
    );
};

export default Department;
